module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp1_8023.7209f41c.png";